import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const CalendarTodayFilled: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width={props.width ? props.width : "13.5"}
      height={props.height ? props.height : "15"}
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 13.5 15"
      {...props}
    >
      <g>
        <path d="M12.1666 2.125H11.5833V1.04167H10.4166V2.125H4.58329V1.04167H3.41663V2.125H2.83329C2.19163 2.125 1.66663 2.6125 1.66663 3.20833V11.875C1.66663 12.4708 2.19163 12.9583 2.83329 12.9583H12.1666C12.8083 12.9583 13.3333 12.4708 13.3333 11.875V3.20833C13.3333 2.6125 12.8083 2.125 12.1666 2.125ZM12.1666 11.875H2.83329V4.83333H12.1666V11.875Z"/>
      </g>
    </StyledSVGIcon>
  );
};